import React from 'react';
import { SupportedDevice } from 'lavva.webbluetooth';
import { useHorizontalScroll } from '../../hooks/use-scroll';
import { ProductListItem } from '../product-list-item';
import './index.scss';

type ProductListProps = {
  channelsPerSelectedType: SupportedDevice[];
};

const ProductList: React.FC<ProductListProps> = ({ channelsPerSelectedType }) => {
  const { scrollableRef } = useHorizontalScroll<HTMLDivElement>();

  return (
    <div className="product-list" ref={scrollableRef}>
      {channelsPerSelectedType.map((device, index) => (
        <ProductListItem key={index} device={device} type="product" />
      ))}
    </div>
  );
};

export default ProductList;
